import { Stack } from '@mui/material';
import { MprcContainer, MprcFormBarHeader, MprcStringToHtml } from 'components';
import { ButtonBack } from 'components/buttons';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

////////////////////////////////////////////////////////////////////////////

interface IProps {
    title: string | string[];
    canBack?: boolean;
    subtitle?: string | string[];
    otherAction?: React.ReactNode;
}

////////////////////////////////////////////////////////////////////////////

export const DevPlanHeader: React.FC<IProps> = (props) => {

    const { t } = useTranslation("lms");
    const navigate = useNavigate();

    const { canBack = true, title, subtitle, otherAction } = props;

    const items = useMemo(() => {
        const actions: React.ReactNode[] = [];
        actions.push(
            canBack
                ? <ButtonBack
                    key="btnBack"
                    rounded
                    size="large"
                    variant="text"
                    onClick={() => navigate(-1)}
                />
                : <div></div>
        );


        actions.push(
            <Stack direction="column" alignItems="end">
                <MprcStringToHtml
                    text={title ?? t("DevPlan.Edit.View.Title")}
                    separator={<span>&nbsp;&bull;&nbsp;</span>}
                    color="muted"
                    typographProps={{ variant: "h2" }}
                />
                <MprcStringToHtml text={subtitle} separator={<span>&nbsp;&bull;&nbsp;</span>}
                    typographProps={{ variant: "subtitle2" }}
                />
            </Stack>
        );

        if (otherAction) actions.push(otherAction);

        return actions;
    }, [props]);

    return (
        <MprcContainer>
            <MprcFormBarHeader actions={items} />
        </MprcContainer>
    );
};
